module.exports = __webpack_public_path__ + "img/rogier_mars.f0712d9c.png";